export const SET_FILES = "SET_FILES";
export const ADD_FILES = "ADD_FILES";
export const OVERWRITE_FILES = "OVERWRITE_FILES";
export const REMOVE_FILE = "REMOVE_FILE";
export const CLEAR = "CLEAR";
export const SET_ERRORS = "SET_ERRORS";
export const ADD_ERRORS = "ADD_ERRORS";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export const OVERWRITE_FILES_NO_CALLBACK = "OVERWRITE_FILES_NO_CALLBACK";
export const SET_TRACK_FILES = "SET_TRACK_FILES";